module.exports = __webpack_public_path__ + "img/2.aae0005f.png";